import WidgetBase from '../widget.base';
import { mq } from 'App/lib/util';
import featSniffer from 'App/lib/featureDetection';

export default class EventsCarouselWidget extends WidgetBase {
    static selector = '[data-ww-events-carousel]';
    inner;
    cards;
    threshold = 100;
    currentCardIndex = 0;
    transitioning = false;
    isDesktop = false;

    constructor(el) {
        super(el);

        if (!this.el) {
            return;
        }

        this.isDesktop = mq('md');

        this.el.querySelector('[data-pager-prev]')
            .addEventListener('click', () => {

                if (this.transitioning) {
                    return;
                }

                this.transitioning = true;

                this.inner.style.transition = '';
                this.inner.style.transform = 'translateX(-100%)';

                let $el = this.el.querySelector('.is-ref');

                $el.classList.remove('is-ref');

                let $nextCard = this.prev($el, 3);

                $nextCard.classList.add('is-ref');

                $nextCard.style.order = 1;

                for(let i = 2; i <= this.cards.length; i++) {
                    $nextCard = this.next($nextCard);
                    $nextCard.style.order = i;
                }

                setTimeout(() => {
                    this.inner.style.transition = 'transform 0.5s ease-in-out';
                    this.inner.style.transform = 'translateX(0)';
                }, 0);

                setTimeout(() => {
                    this.transitioning = false;
                }, 500);
            });

        this.el.querySelector('[data-pager-next]')
            .addEventListener('click', () => {

                if (this.transitioning) {
                    return;
                }

                this.transitioning = true;

                this.inner.style.transition = 'transform 0.5s ease-in-out';
                this.inner.style.transform = 'translateX(-100%)';

                let $el = this.el.querySelector('.is-ref');

                $el.classList.remove('is-ref');

                let $nextCard = this.next($el, 3);

                $nextCard.classList.add('is-ref');

                setTimeout(() => {
                    $nextCard.style.order = 1;

                    for(let i = 2; i <= this.cards.length; i++) {
                        $nextCard = this.next($nextCard);
                        $nextCard.style.order = i;
                    }

                    this.inner.style.transition = '';
                    this.inner.style.transform = 'translateX(0)';

                    this.transitioning = false;

                }, 500);
            });

        this.inner = this.el.querySelector('[data-carousel-inner]');
        this.cards = this.el.querySelectorAll('[data-carousel-card]');

        // add touch events if supported
        if (featSniffer.touch()) {
            this.addTouchEvents(this.inner);
        }

        // update on resize
        window.addEventListener('resize', () => {
            let isDesktop = mq('md');

            if (isDesktop != this.isDesktop) {
                if (isDesktop) {
                    this.initDesktop();
                } else {
                    this.initMobile();
                }
            }

            this.isDesktop = isDesktop;
        });

        if (this.isDesktop) {
            this.initDesktop();
        } else {
            this.initMobile();
        }

        // tell dom we're ready
        setTimeout(() => this.loaded());
    }

    initDesktop() {
        this.inner.style.transform = 'translate3d(0,0,0)';
        this.cards.forEach((card, index) => {
            card.classList.remove('is-ref');
            card.style.opacity = 1;
            card.style.order = index + 1;
        });

        this.cards[0].classList.add('is-ref');
    }

    initMobile() {
        this.inner.style.transform = 'translate3d(0,0,0)';
        this.cards.forEach((card, index) => {
            card.classList.remove('is-ref');
            card.style.opacity = 1;
            card.style.order = index + 1;
        });

        this.cards[0].classList.add('is-ref');

        this.currentCardIndex = 0;
        this.updateCardOpacity(0);
    }

    next(element, times = 1) {

        for (let i = 0; i < times; i++) {
            element = element.nextElementSibling || this.cards[0];
        }

        return element;
    }

    prev(element, times = 1) {

        for (let i = 0; i < times; i++) {
            element = element.previousElementSibling || this.cards[this.cards.length - 1];
        }

        return element;
    }

    getCardOffsetX(index) {
        let runningTotal = 0;

        for (let i = 0; i < index; i++) {
            runningTotal += this.cards[i].offsetWidth;
        }

        return runningTotal * -1;
    }

    updateCardOpacity(offsetX) {
        //swap sign
        offsetX = offsetX * -1;

        let runningTotal = 0;

        let viewportStart = offsetX;
        let viewportEnd = offsetX + this.inner.offsetWidth;

        for (let i = 0; i < this.cards.length; i++) {

            let cardWidth = this.cards[i].offsetWidth;
            let cardCenter = runningTotal + (cardWidth / 2);

            let delta = 0;

            if (cardCenter < viewportStart) {
                delta = Math.abs(cardCenter - viewportStart);
            }

            if (cardCenter > viewportEnd) {
                delta = Math.abs(cardCenter - viewportEnd);
            }

            let ratio = delta / cardWidth;

            let opacity = 1 - ratio;

            opacity = Math.max(opacity, 0.5);

            this.cards[i].style.opacity = opacity;

            runningTotal += cardWidth;
        }
    }

    addTouchEvents(element) {
        let isTouchStart = false;

        // initial mouse X for `mousedown`
        let touchX;
        let touchY;

        // element transform style before/after
        let transformX;

        // element X before and after move
        let elementX = 0;

        element.addEventListener('touchstart', onTouchStart.bind(this));

        /**
         * Listens to `mousedown` event.
         *
         * @param {Object} event - The event.
         */
        function onTouchStart(event) {
            element.classList.add('dragging');
            touchX = event.touches[0].clientX;
            touchY = event.touches[0].clientY;
            isTouchStart = true;

            transformX = parseTransformX(element.style.transform);
        }

        // mouse button released
        element.addEventListener('touchend', onTouchEnd.bind(this));

        /**
         * Listens to `mouseup` event.
         *
         * @param {Object} event - The event.
         */
        function onTouchEnd(event) {
            isTouchStart = false;
            element.classList.remove('dragging');

            elementX = element.style.transform ? parseTransformX(element.style.transform) : transformX;

            const transformDelta = elementX - transformX;

            if (Math.abs(transformDelta) > this.threshold) {
                if(transformDelta < 0) {
                    if(this.currentCardIndex !== this.cards.length - 1) {
                        this.currentCardIndex++;
                        let x = this.getCardOffsetX(this.currentCardIndex);
                        element.style.transform = 'translate3d(' + x + 'px, 0, 0)';
                        this.updateCardOpacity(x);
                    }else{
                        // sets slide back to start position
                        element.style.transform = 'translate3d(' + transformX + 'px, 0, 0)';
                        this.updateCardOpacity(transformX);
                    }
                }else{
                    if(this.currentCardIndex !== 0) {
                        this.currentCardIndex--;
                        let x = this.getCardOffsetX(this.currentCardIndex);
                        element.style.transform = 'translate3d(' + x + 'px, 0, 0)';
                        this.updateCardOpacity(x);
                    }else{
                        // sets slide back to start position
                        element.style.transform = 'translate3d(' + transformX + 'px, 0, 0)';
                        this.updateCardOpacity(transformX);
                    }
                }
            }else{
                element.style.transform = 'translate3d(' + transformX + 'px, 0, 0)';
                this.updateCardOpacity(transformX);
            }
        }

        // gets the x transform value from an element with a transform3d style applied
        function parseTransformX(transform) {
            return parseInt(transform.split('(')[1].split(',')[0])
        }

        // need to attach to the entire document
        // in order to take full width and height
        // this ensures the element keeps up with the mouse
        document.addEventListener('touchmove', onTouchMove.bind(this));

        /**
         * Listens to `mousemove` event.
         *
         * @param {Object} event - The event.
         */
        function onTouchMove(event) {
            if (!isTouchStart) return;
            var deltaX = event.touches[0].clientX - touchX;
            var deltaY = event.touches[0].clientY - touchY;

            const absDeltaX = Math.abs(deltaX);
            const absDeltaY = Math.abs(deltaY);

            if(absDeltaY > absDeltaX) {
                return false;
            }

            element.style.transform = 'translate3d(' + (transformX + deltaX) + 'px, 0, 0)';

            this.updateCardOpacity(transformX + deltaX);
        }
    }
}